module.exports = __webpack_public_path__ + "img/folder.cbe0c83e.svg";